// removed by extract-text-webpack-plugin
module.exports = {"about":"_3hjzWDD7tUHsp5T2Q6ePt3_0","contactForm":"_1lFWgZWlo72d08BQZMUkow_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-f793b566!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/About.vue
// module id = 67
// module chunks = 2